import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { FileText, Download, Loader2 } from "lucide-react";

export const AttachmentView = ({ attachment }) => {
  const [url, setUrl] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let revoked = null;
    let active = true;
    (async () => {
      try {
        const res = await api.get(`/files/${attachment.path}`, { responseType: "blob" });
        if (!active) return;
        const objUrl = URL.createObjectURL(res.data);
        revoked = objUrl;
        setUrl(objUrl);
      } catch (e) {
        // ignore
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => { active = false; if (revoked) URL.revokeObjectURL(revoked); };
  }, [attachment.path]);

  if (attachment.is_image) {
    return (
      <div className="mt-1.5 overflow-hidden rounded-lg border border-black/5" data-testid="chat-attachment-image">
        {loading || !url ? (
          <div className="flex h-32 w-48 items-center justify-center bg-slate-100"><Loader2 className="h-5 w-5 animate-spin text-slate-400" /></div>
        ) : (
          <a href={url} target="_blank" rel="noreferrer">
            <img src={url} alt={attachment.name} className="max-h-56 max-w-full object-cover" />
          </a>
        )}
      </div>
    );
  }

  return (
    <a
      href={url || undefined}
      download={attachment.name}
      data-testid="chat-attachment-file"
      className="mt-1.5 inline-flex items-center gap-2 rounded-lg border border-black/10 bg-white/80 px-3 py-2 text-xs text-navy hover:bg-white"
    >
      {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <FileText className="h-4 w-4 text-gold-dark" />}
      <span className="max-w-[180px] truncate font-medium">{attachment.name}</span>
      <Download className="h-3.5 w-3.5 text-slate-400" />
    </a>
  );
};
